import PropTypes from "prop-types"
import { REQUEST_TYPES } from "../constants"

// Helper function to get sort direction for ARIA
const getSortDirection = (sorter, field) => {
  if (!sorter || sorter.field !== field) return "none"
  return sorter.order === "ascend" ? "ascending" : "descending"
}

const getHeaders = (sorter) => {
  let actionsWidth;
  if (sorter && sorter.type === REQUEST_TYPES.requested) {
    actionsWidth = 200;
  } else if (sorter && sorter.type === REQUEST_TYPES.upcoming) {
    actionsWidth = 92;
  } else {
    actionsWidth = 110;
  }

  return [
    {
      title: "Experience Date & Time",
      dataIndex: "booked_date",
      key: "booked_date",
      sorter: true,
      width: 250,
      ellipsis: true,
      "aria-sort": getSortDirection(sorter, "sort_by_user_full_name"),
      "aria-label": "Client name, sortable"
    },
    {
      title: "Client",
      dataIndex: "client_name",
      key: "client_name",
      sorter: true,
      width: 200,
      ellipsis: true,
      "aria-sort": getSortDirection(sorter, "sort_by_groups"),
      "aria-label": "Client group, sortable"
    },
    {
      title: "Experience",
      dataIndex: "experience",
      key: "experience",
      width: 200,
      ellipsis: true,
      "aria-label": "Email address"
    },
    {
      title: "Total",
      dataIndex: "total_amount",
      key: "total_amount",
      sorter: false,
      width: 120,
      ellipsis: true,
      "aria-label": "Total amount"
    },
    {
      title: "Payment Status",
      dataIndex: "payment_status",
      key: "payment_status",
      sorter: true,
      width: 200,
      ellipsis: false,
      "aria-label": "Payment status"
    },
    {
      title: "Booked On",
      dataIndex: "created_at",
      key: "created_at",
      sorter: true,
      width: 200,
      ellipsis: true,
      "aria-sort": getSortDirection(sorter, "sort_by_last_trip_date"),
      "aria-label": "Experience date, sortable"
      // defaultSortOrder: "descend" // Default sort by date descending
    },
    {
      title: "Booking ID",
      dataIndex: "booking_id",
      key: "booking_id",
      width: 120,
      ellipsis: true,
      "aria-sort": getSortDirection(sorter, "sort_by_total_booking_amount"),
      "aria-label": "Year to date spend, sortable"
    },
    {
      title: "Actions",
      dataIndex: "actions",
      width: actionsWidth, //change width to 100 in case of more icon
      key: "actions",
      "aria-label": "Actions"
    }
  ];
}

getHeaders.propTypes = {
  sorter: PropTypes.object
}

export { getHeaders }
